import { FormOutlined } from "@ant-design/icons";
import { RenglonSemaforo } from "../RenglonSemaforo";
import { TituloSemaforo } from "../TituloSemaforo";

export const CapturandoDatos = ({ asistenciasSemaforo }) => {
  const asistencias = asistenciasSemaforo.filter((a) => a.estatusID === 1);
  return (
    <section className="semaforo-general__columna" aria-label="Capturando datos">
      <TituloSemaforo icon={<FormOutlined />} titulo="Datos capturados - Buscando proveedor" count={asistencias.length} />
      {asistencias.length === 0 && <p className="semaforo-general__vacio">Sin asistencias en captura</p>}
      {asistencias.map((a) => (
        <RenglonSemaforo
          key={a.asistenciaID}
          asistencia={a}
          fecha={a.fechaLlamadaIniciada}
        />
      ))}
    </section>
  );
};
